import Debouncer from '../../../packages/neb-utils/debouncer';

import { trackMapper } from './track-mapper';

import { identifyUser, track } from '.';

export const TRACK_EVENTS = {
  NARRATIVE_COPIED: 'NARRATIVE_COPIED',
  GENERATE_AI_SUMMARY: 'GENERATE_AI_SUMMARY',
  LOGIN_ATTEMPT: 'login_attempt',
  RESET_VERIFICATION_REQUESTED: 'Send_Verification_Requested',
  RESET_VERIFICATION_SUBMITTED: 'Reset_verification_submitted',
  SPECIALIST_USER_ADDED: 'Specialist_User_Added',
  STAFF_USER_ADDED: 'Staff_User_Added',
  CARE_PACKAGE_CREATED: 'care_package_created',
  CARE_PACKAGE_SUBSCRIPTION_CREATED: 'care_package_subscription_created',
  CARE_PACKAGE_COMPLETED: 'care_package_completed',
  CARE_PACKAGE_SUBSCRIPTION_COMPLETED: 'care_package_subscription_completed',
};

export const UNAUTHENTICATED_USER = {
  email: 'unauthenticated_user',
  firstName: 'Unauthenticated',
  lastName: 'User',
};

export const unauthenticatedUserDebounceCallback = (eventName, params) => {
  if (params.status === 'success') {
    const { email } = params;
    identifyUser({ email });
  }

  track(eventName, params);
};

export const loginTrackDebouncer = new Debouncer(
  unauthenticatedUserDebounceCallback,
);

export const resetPasswordVerificationDebouncer = new Debouncer(
  unauthenticatedUserDebounceCallback,
);

export const resetPasswordSubmittedDebouncer = new Debouncer(
  unauthenticatedUserDebounceCallback,
);

export const userpilotTrackEvent = {
  loginAttempt: ({ email, error = '', mfaMethod, mfaRememberDevice }) =>
    loginTrackDebouncer.debounceFirstCall(TRACK_EVENTS.LOGIN_ATTEMPT, {
      email,
      status: error ? 'failed' : 'success',
      reason: error,
      mfaMethod,
      mfaRememberDevice,
    }),
  resetVerificationRequested: ({ email }) =>
    resetPasswordVerificationDebouncer.debounce(
      TRACK_EVENTS.RESET_VERIFICATION_REQUESTED,
      { email },
    ),
  resetVerificationSubmitted: ({ email, error }) =>
    resetPasswordSubmittedDebouncer.debounce(
      TRACK_EVENTS.RESET_VERIFICATION_SUBMITTED,
      {
        email,
        reason: error,
        status: error ? 'failed' : 'success',
      },
    ),
  narrativeCopied: ({ s3FileKey }) =>
    track(TRACK_EVENTS.NARRATIVE_COPIED, {
      s3FileKey,
    }),
  generateAiSummary: ({ s3FileKey }) =>
    track(TRACK_EVENTS.GENERATE_AI_SUMMARY, {
      s3FileKey,
    }),
  specialistUserAdded: (params, locations) =>
    track(
      TRACK_EVENTS.SPECIALIST_USER_ADDED,
      trackMapper.specialistUserAdded(params, locations),
    ),
  staffUserAdded: (params, locations) =>
    track(
      TRACK_EVENTS.STAFF_USER_ADDED,
      trackMapper.staffUserAdded(params, locations),
    ),
  carePackageCreated: params =>
    track(
      TRACK_EVENTS.CARE_PACKAGE_CREATED,
      trackMapper.carePackageCreated(params),
    ),
  carePackageSubscriptionCreated: params =>
    track(
      TRACK_EVENTS.CARE_PACKAGE_SUBSCRIPTION_CREATED,
      trackMapper.carePackageSubscriptionCreated(params),
    ),
  carePackageCompleted: params =>
    track(
      params.subscription
        ? TRACK_EVENTS.CARE_PACKAGE_SUBSCRIPTION_COMPLETED
        : TRACK_EVENTS.CARE_PACKAGE_COMPLETED,
      trackMapper.carePackageCompleted(params),
    ),
};
